/* @jsx h */
import { useMenu } from "@app/vue/providers/Menu";
import { CartServiceMethodType } from "@lemmonhq/types";
import { defineComponent, h, onMounted } from "vue";
import { calculateAllowedOrderServiceMethods } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";

interface CartServiceMethodSelectorProps {
  allowedMethods: CartServiceMethodType[];
  selectedMethod?: CartServiceMethodType;
  onMethodChange: (method: CartServiceMethodType) => void;
}

export const CartServiceMethodSelector =
  defineComponent<CartServiceMethodSelectorProps>({
    name: "CartServiceMethodSelector",
    props: ["allowedMethods", "selectedMethod", "onMethodChange"],
    setup(props) {
      const { cart, shop } = useMenu();
      const { t } = useLocalization();
      onMounted(() => {
        if (!shop.value) return;
        const allowedMethods = calculateAllowedOrderServiceMethods(shop.value);
        if (!cart.cart.serviceMethod) {
          if (allowedMethods.includes("delivery")) {
            cart.cart.serviceMethod = "delivery";
          } else if (allowedMethods.includes("takeaway")) {
            cart.cart.serviceMethod = "takeaway";
          }
        }
      });
      return () => (
        <div class="flex items-center bg-base-200 rounded-full p-1 mr-2">
          {props.allowedMethods.includes("takeaway") && (
            <button
              class={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 border flex justify-center items-center gap-1 ${
                props.selectedMethod === "takeaway"
                  ? "bg-primary text-primary-content shadow-sm"
                  : "text-base-content/70 hover:text-base-content"
              }`}
              onClick={() => props.onMethodChange("takeaway")}
            >
              <span class="hidden material-symbols-outlined ml-auto">
                takeout_dining
              </span>
              <span class=" md:inline">
                {t("customer.shop_shell.takeaway")}
              </span>
            </button>
          )}
          {props.allowedMethods.includes("delivery") && (
            <button
              class={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 border flex justify-center items-center gap-1 ${
                props.selectedMethod === "delivery"
                  ? "bg-primary text-primary-content shadow-sm"
                  : "text-base-content/70 hover:text-base-content"
              }`}
              onClick={() => props.onMethodChange("delivery")}
            >
              <span class="hidden material-symbols-outlined ml-auto">
                local_shipping
              </span>
              <span class=" md:inline">
                {t("customer.shop_shell.delivery")}
              </span>
            </button>
          )}
        </div>
      );
    },
  });
